module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "bg-color light-gray"
  }, [_c('c-content', [_c('div', {
    slot: "noscroll"
  }, [_c('div', {
    staticClass: "text-center failed-status"
  }, [_c('img', {
    staticClass: "failed-icon",
    attrs: {
      "src": require("../../../assets/images/pay/pay-fail@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-color orange mt-20 mb-10 failed-text"
  }, [_c('i', {
    staticClass: "text-color orange s-icon-times-circle"
  }), _vm._v("\n            支付失败\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-color gray"
  }, [_vm._v("请重新支付或选择其它支付方式")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-selector"
  }, [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.repayWithThirdPay($event)
      }
    }
  }, [_vm._v("使用其他方式支付")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center footer-info"
  }, [_c('div', [_vm._v("支付遇到问题？请联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('a', {
    staticClass: "text-color primary tele",
    attrs: {
      "href": "tel:4001683399"
    }
  }, [_vm._v("400-168-3399")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be5c6632","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay-status/pay-failed/index.vue
// module id = 1070
// module chunks = 2